import React from 'react';
import ClassroomSchoolLetter, { classroomGlyphMetrics, classroomWordUnits } from './ClassroomSchoolLetter';

// Every character uses the same school family, including the original an masters.
export default function ClassroomBalloonWord({ word }) {
  const letters = [...word];
  const units = classroomWordUnits(word);
  return <span className="letter-sequence classroom-balloon-word" aria-hidden="true" style={{ '--school-units': units }}>
    {letters.map((letter, index) => {
      const { advance, offset } = classroomGlyphMetrics(letter);
      return <span key={index} data-letter={letter} className="sequence-glyph"
        style={{ '--school-advance': advance, '--school-offset': offset }}><ClassroomSchoolLetter letter={letter} /></span>;
    })}
  </span>;
}
